<template>
    <div>
        <button
            class="btn btn-md is-danger"
            :class="[{ 'is-loading': loading }, buttonSizeClass]"
            :disabled="disabled"
            :title="disabled ? disabledReason : null"
            @click="showConfirm"
        >
            Begär anonymisering
        </button>

        <adaptive-modal
            :name="`confirm-customer-anonymization-${customer.id}`"
            title="Begär anonymisering"
            primary-button-text="Anonymisera"
            primary-button-class="is-danger"
            @save="storeAnonymizationRequest"
            @hide="loading = false"
        >
            <p>
                Vill du verkligen begära anonymisering? Anonymiseringen slutförs efter attestering av annan person.
            </p>
        </adaptive-modal>
    </div>
</template>
<script>
    export default {
        props: {
            customer: {
                type: Object,
                required: true,
            },
            size: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: null,
            },
            disabledReason: {
                type: String,
                required: false,
                default: null,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            buttonSizeClass() {
                return this.size ? 'btn-' + this.size : null;
            },
        },

        methods: {
            showConfirm() {
                this.loading = true;
                this.$modal.show('confirm-customer-anonymization-' + this.customer.id);
            },

            storeAnonymizationRequest() {
                this.$modal.hide('confirm-customer-anonymization-' + this.customer.id);
                axios.post(route('api.gdpr.anonymization-requests.store'),  { 'customerId': this.customer.id })
                    .then(({ data }) => {
                        this.$emit('requested', data);
                        flash_success('En begäran om anonymisering skapad!');
                    }).catch((error) => {
                        if (error.response.data.message) {
                            flash_error(error.response.data.message);
                        } else {
                            flash_error('Begäran misslyckades.');
                        }
                    }).then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
